/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DAI_ZERO_REVIEW_MODELS = gql`
  query DAIZeroReviewModels {
    daiZeroReviewModels {
      version
      deployed
      manifestAvailable
    }
  }
`
